import * as TypeStyle from 'typestyle';

export const shineWidth = 80;
export const ShineAnimationDurationMs = 1600;
export const getBackgroundColor = (alpha: number = 1): string => `var(--loading-bone-background-color, rgba(230, 230, 230, ${alpha}))`; // #e6e6e6
export const getShineColor = (alpha: number = 1): string => `var(--loading-bone-shine-color, rgba(245, 245, 245, ${alpha}))`; // #f5f5f5

export const ShineStyleName = TypeStyle.style({
  $nest: {
    '@media (prefers-reduced-motion: no-preference)': {
      animationDuration: `${ShineAnimationDurationMs}ms`,
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite',
      height: '100%',
      position: 'absolute',
    }
  }
});

const LoadingBoneBaseStyleName = TypeStyle.style({
  backgroundColor: getBackgroundColor(1),
  borderRadius: `var(--loading-bone-border-radius, 2px)`,
  height: '1rem',
  overflow: 'hidden',
  position: 'relative',
});

export const LoadingBoneStyleName = `${LoadingBoneBaseStyleName} ${TypeStyle.style({
  $nest: {
    [`& + .${LoadingBoneBaseStyleName}`]: {
          marginTop: 8,
      $nest: {
        '&:nth-child(even)': {
          width: '70%'
        },
      }
    },
  }
})}`;
